import { text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";

export default class DocketTemplateType extends BaseModel {
  static table = "docket_template_types";
  @text("html") html: string;
  @text("css") css: string;
}
